import React from 'react';
import styles from './LoginForm.scss';
import { IRegisterOptions } from './RegisterForm';
import ButtonRound from './ButtonRound';
import FormError from './FormError';
import { IUserState } from '../stores/useUser';
import getUid from '../utils/getUid';
import TextField from './MaterialUi/TextField';
import Button from './MaterialUi/Button';

export interface ILoginFormProps {
    className?: string;
    handleSubmit: () => void;
    name: string;
    setName: (name: string) => void;
    pass: string;
    setPass: (pass: string) => void;
    isLoading: boolean;
    error: string;
    buttonText?: string;
}

// class LoginForm extends React.Component<ILoginFormProps, ILoginFormState> {
const LoginForm: React.FC<React.PropsWithChildren<ILoginFormProps>> = ({
    handleSubmit,
    name,
    setName,
    pass,
    setPass,
    className = '',
    error,
    isLoading,
    buttonText
}) => {
    const [labelUid] = React.useState(() => getUid('formId'));

    return (
        <form className={styles.loginForm + ' ' + className} action="/user/login" method="post" acceptCharset="UTF-8" onSubmit={handleSubmit}>
            <TextField
                // autocorrect="none"
                // autocapitalize="none"
                // spellcheck="false"
                // autofocus="autofocus"
                label="E-Mail-Adresse oder Benutzername"
                type="text"
                id={`${labelUid}Name`}
                name="name"
                value={name}
                inputProps={{ maxLength: 254 }}
                required={true}
                aria-required="true"
                onChange={(ev) => {
                    setName(ev?.target?.value);
                }}
                autoComplete='username'
            />
            <TextField
                label="Passwort"
                type="password"
                id={`${labelUid}Pass`}
                name="pass"
                value={pass}
                onChange={(ev) => {
                    setPass(ev?.target?.value);
                }}
                // size="60"
                inputProps={{ maxLength: 128 }}
                required={true}
                aria-required="true"
                autoComplete="current-password"
            />

            <FormError text={error} />

            <div className={styles.actions}>
                <Button type="submit" loading={isLoading}>
                    {buttonText || 'Anmelden'}
                </Button>
            </div>

            <div className={styles.annotation}>
                * die gekennzeichneten Felder sind Pflichtfelder
            </div>
        </form>
    );
    // }
};

export default LoginForm;
